import '../sass/pages/login.scss';

require('../webroot/assets/global/plugins/jquery-validation/js/jquery.validate.min.js');
require('../webroot/assets/global/plugins/jquery-validation/js/additional-methods.min.js');

require('../webroot/assets/global/scripts/app.min.js');
require('../webroot/assets/pages/scripts/login.js');



// WEBPACK FOOTER //
// ./bundles/login.js